import DataService from "../../../service/DataService";
import ValidService from "../../../service/ValidService";
let model = {};

model.dataForm = {
    id: null, // optional Mã tự sinh
    duyet: {
        duoc_duyet: null, // optional Cho biết dịch vụ đã được duyệt hay chưa. true: đã duyệt, false: từ chối, null: chờ duyệt
        thoi_diem_duyet: null, // optional Cho biết thời điểm dịch vụ đã được duyệt hoặc từ chối
        nguoi_duyet_id: null,
    },
    don_vi_cung_cap_id: null,
    diem_den_an_toan_id: null, // required điểm đến id
    loai: "entertainment", // required, enum(hotel, restaurant, entertainment, ticket, yellow_page_place) Loại dịch vụ du lịch
    link_dich_vu: [{ // optional
        id: null, // optional id của dịch vụ
        link: null
    }], // optional Tên dịch vụ
    ly_do_tu_choi: null, // optional Lý do từ chối
    visible: null,
    giai_tri: { // optional Giải trí
        ten: null, // required Tên địa điểm giải trí
        anh_hien_thi: null, // required Ảnh hiển thị
        mo_ta: null, // optional Giới thiệu về khu giải trí
        chi_tiet: null,
    }, // optional Chi tiết về khi giải trí
    thong_tin_chung: // required Thông tin khu giải trí
    {
        ten: null, // required Tên khu giải trí
        dia_chi: null, // optional Địa chỉ khu giải trí
        dien_thoai: null, // required Điện thoại liên hệ khu giải trí
        email: null, // optional Email liên hệ khu giải trí
        website: null, // optional Website giới thiệu khu giải trí
        doi_tuong: null, // optional Đối tượng khách hàng hướng tới
        album_anh: [],
    },
    link_mang_xa_hoi: DataService.linkMangXaHoi
};
model.albumUploadOption = {
    accept: ".jpg, .png, .jpeg",
    dialogImageUrl: "",
    dialogVisible: false,
    fileList: []
}

// dữ liệu mẫu các form khác
model.dataFormOther = {
    id: null, // optional
    duyet: // optional
    {
        duoc_duyet: null, // required Cho biết dịch vụ đã được duyệt hay chưa
        thoi_diem_duoc_duyet: null, // optional Cho biết thời điểm dịch vụ đã được duyệt
        nguoi_duyet_id: null, // optional Mã người duyệt
    },
    thong_tin_chung: // required Thông tin khu giải trí
    {
        ten: null, // required Tên khu giải trí
        dia_chi: null, // optional Địa chỉ khu giải trí
        dien_thoai: null, // required Điện thoại liên hệ khu giải trí
        email: null, // optional Email liên hệ khu giải trí
        website: null, // optional Website giới thiệu khu giải trí
        doi_tuong: null, // optional Đối tượng khách hàng hướng tới
    },
    mo_ta: null, // optional Mô tả khu giải trí
    chi_tiet: null, // optional Chi tiết khu giải trí
    mediaId: null, // optional id media
    lastModificationTime: null, // optional Thời gian lần sửa bản ghi cuối cùng
    lastModifierUserId: null, // optional Mã người sửa cuối
    fileUploadOption: {
        AnhDaiDien: {
            limit: 1,
            accept: ".jpg, .png, .jpeg",
            dialogImageUrl: "",
            dialogVisible: false,
            fileList: []
        },
    },
};

model.validForm = {
    'don_vi_cung_cap_id': [ValidService.required],
    'giai_tri.ten': [ValidService.required],
    'giai_tri.anh_hien_thi': [ValidService.required],
    'giai_tri.mo_ta': [ValidService.required],
    'giai_tri.chi_tiet': [ValidService.required],
    'gia_tri_uu_dai': []
}

model.tableRules = {
    data: [],
    lengthMenu: [10, 20, 50, 100, 500],
    allowPaging: true,
    allowSorting: true,
    allowSelect: false,
    showFormSearch: false,
    showUrl: true,
    total: 0,
    page: 1,
    limit: 10,
    offset: 0,
    sort: "",
    defaultSort: ["", "descending"],
    filters: "",
    recordSelected: [],
    dataSearch: {
        value: {
            "giai_tri.ten": "",
            tinh_thanh: "",
            'duyet.duoc_duyet': '',
            // ready: false,
            visible: ""
        },
        valid: {
            "giai_tri.ten": [],
            tinh_thanh: [],
            'duyet.duoc_duyet': [],
        },
        operator: {
            "giai_tri.ten": ":regex_i:", //:regex:, $vn_text=Viêt nam
            tinh_thanh: ":regex:",
            'duyet.duoc_duyet': '',
        }
    }
};

export default model;
